import React from "react";
import { Col } from "react-bootstrap";
var Winback = function (props) {
    var _a, _b, _c;
    return (React.createElement("section", { id: "winback" },
        React.createElement("label", { className: "DMSanBold_18_700 txt_blackOne1 heading-padding" },
            "Winback",
            React.createElement("i", { className: "edel-icon-win-back fw-bolder ms-2" })),
        React.createElement(Col, null,
            React.createElement("div", { className: "d-grid" },
                React.createElement("label", { className: "DMSanN_14_400 txt_secondary-gray" },
                    "Last Call Date",
                    React.createElement("div", { className: "DMSanN_16_400 txt_blackOne1" }, (_a = props === null || props === void 0 ? void 0 : props.clientLifeCycle) === null || _a === void 0 ? void 0 : _a.lastcalldate)),
                React.createElement("label", { className: "DMSanN_14_400 txt_secondary-gray" },
                    "Last Meeting Date",
                    React.createElement("div", { className: "DMSanN_16_400 txt_blackOne1" }, (_b = props === null || props === void 0 ? void 0 : props.clientLifeCycle) === null || _b === void 0 ? void 0 : _b.lastmeetingdate)),
                React.createElement("label", { className: "DMSanN_14_400 txt_secondary-gray" },
                    "Summary",
                    React.createElement("div", { className: "DMSanN_16_400 txt_blackOne1" }, (_c = props === null || props === void 0 ? void 0 : props.clientLifeCycle) === null || _c === void 0 ? void 0 : _c.pimode))))));
};
export default Winback;
